export default __webpack_public_path__ + "static/media/blackslider6.0e229dde.png";